import React from 'react';
import { Box, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import BlockIcon from '@mui/icons-material/Block';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import HideImageIcon from '@mui/icons-material/HideImage';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import PercentIcon from '@mui/icons-material/Percent';
import NumbersIcon from '@mui/icons-material/Numbers';
import TuneIcon from '@mui/icons-material/Tune';

interface MobilBulkActionButtonsProps {
  selectedBulkAction: string | null;
  selectedItemsCount: number;
  onBulkDelete: () => void;
  onBulkInactivate: () => void;
  onBulkPriceUpdate: () => void;
  onBulkPurchasePriceUpdate: () => void;
  onBulkOpenForEcommerce: () => void;
  onBulkCloseForEcommerce: () => void;
  onBulkToggleQRMenu: () => void;
  onBulkToggleKiosk: () => void;
  onBulkDeleteImages: () => void;
  onBulkAssignWarehouse: () => void;
  onBulkUpdateVatRate: () => void;
  onBulkUpdateDepartmentNo: () => void;
  onBulkUpdateVatAndDept: () => void;
  onDeleteAllItems: () => void;
}

export const MobilBulkActionButtons: React.FC<MobilBulkActionButtonsProps> = ({
  selectedBulkAction,
  selectedItemsCount,
  onBulkDelete,
  onBulkInactivate,
  onBulkPriceUpdate,
  onBulkPurchasePriceUpdate,
  onBulkOpenForEcommerce,
  onBulkCloseForEcommerce,
  onBulkToggleQRMenu,
  onBulkToggleKiosk,
  onBulkDeleteImages,
  onBulkAssignWarehouse,
  onBulkUpdateVatRate,
  onBulkUpdateDepartmentNo,
  onBulkUpdateVatAndDept,
  onDeleteAllItems,
}) => {
  if (!selectedBulkAction) return null;

  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      {selectedBulkAction === 'delete' && (
        <Button
          fullWidth
          variant="contained"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={onBulkDelete}
          disabled={selectedItemsCount === 0}
        >
          Sil ({selectedItemsCount})
        </Button>
      )}
      {selectedBulkAction === 'inactivate' && (
        <Button
          fullWidth
          variant="contained"
          color="warning"
          startIcon={<BlockIcon />}
          onClick={onBulkInactivate}
          disabled={selectedItemsCount === 0}
        >
          Pasife Al ({selectedItemsCount})
        </Button>
      )}
      {selectedBulkAction === 'price' && (
        <Button
          fullWidth
          variant="contained"
          color="success"
          startIcon={<PriceChangeIcon />}
          onClick={onBulkPriceUpdate}
          disabled={selectedItemsCount === 0}
        >
          Satış Fiyatı Güncelle ({selectedItemsCount})
        </Button>
      )}
      {selectedBulkAction === 'purchasePrice' && (
        <Button
          fullWidth
          variant="contained"
          color="info"
          startIcon={<MonetizationOnIcon />}
          onClick={onBulkPurchasePriceUpdate}
          disabled={selectedItemsCount === 0}
        >
          Alış Fiyatı Güncelle ({selectedItemsCount})
        </Button>
      )}
      {selectedBulkAction === 'ecommerceOpen' && (
        <Button
          fullWidth
          variant="contained"
          color="success"
          startIcon={<StorefrontIcon />}
          onClick={onBulkOpenForEcommerce}
          disabled={selectedItemsCount === 0}
        >
          E-Ticarete Aç ({selectedItemsCount})
        </Button>
      )}
      {selectedBulkAction === 'ecommerceClose' && (
        <Button
          fullWidth
          variant="contained"
          color="error"
          startIcon={<StorefrontIcon />}
          onClick={onBulkCloseForEcommerce}
          disabled={selectedItemsCount === 0}
        >
          E-Ticaretten Kapat ({selectedItemsCount})
        </Button>
      )}
      {selectedBulkAction === 'qrmenu' && (
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          startIcon={<PhotoCameraIcon />}
          onClick={onBulkToggleQRMenu}
          disabled={selectedItemsCount === 0}
        >
          QR Menü'de Aç ({selectedItemsCount})
        </Button>
      )}
      {selectedBulkAction === 'kiosk' && (
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          startIcon={<PhotoCameraIcon />}
          onClick={onBulkToggleKiosk}
          disabled={selectedItemsCount === 0}
        >
          Kiosk'ta Aç ({selectedItemsCount})
        </Button>
      )}
      {selectedBulkAction === 'deleteImages' && (
        <Button
          fullWidth
          variant="contained"
          color="error"
          startIcon={<HideImageIcon />}
          onClick={onBulkDeleteImages}
          disabled={selectedItemsCount === 0}
        >
          Toplu Resim Sil ({selectedItemsCount})
        </Button>
      )}
      {selectedBulkAction === 'assignWarehouse' && (
        <Button
          fullWidth
          variant="contained"
          color="primary"
          startIcon={<WarehouseIcon />}
          onClick={onBulkAssignWarehouse}
          disabled={selectedItemsCount === 0}
        >
          Depoya Ata ({selectedItemsCount})
        </Button>
      )}
      {selectedBulkAction === 'vatRate' && (
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          startIcon={<PercentIcon />}
          onClick={onBulkUpdateVatRate}
          disabled={selectedItemsCount === 0}
        >
          KDV Oranı Güncelle ({selectedItemsCount})
        </Button>
      )}
      {selectedBulkAction === 'departmentNo' && (
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          startIcon={<NumbersIcon />}
          onClick={onBulkUpdateDepartmentNo}
          disabled={selectedItemsCount === 0}
        >
          ÖKC Güncelle ({selectedItemsCount})
        </Button>
      )}
      {selectedBulkAction === 'vatAndDept' && (
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          startIcon={<TuneIcon />}
          onClick={onBulkUpdateVatAndDept}
          disabled={selectedItemsCount === 0}
        >
          KDV + ÖKC Güncelle ({selectedItemsCount})
        </Button>
      )}
      {selectedBulkAction === 'deleteAll' && (
        <Button
          fullWidth
          variant="contained"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={onDeleteAllItems}
        >
          Tüm Stokları Sil
        </Button>
      )}
    </Box>
  );
};

